import {
  Component,
  OnInit
} from '@angular/core';

import {
  Router,
  ActivatedRoute
} from '@angular/router';


import {TranslateService} from '@ngx-translate/core';
import { UserService } from '../../services/user.service';
import { NotificationService } from '../../services/notification.service';
import { ProfileService } from '../../services/profile.service';
//import { NestasToolbarComponent } from '../toolbar/toolbar.component';


import * as _ from 'lodash';

@Component({
  selector: 'sender',
  templateUrl: './sender.component.html',
  styleUrls: ['./sender.component.scss']
})
export class SenderComponent implements OnInit {
  accepted: boolean = false;
  steps = [];
  me = {
    fromEmailVerified: false
  }

  constructor(private _user: UserService, public translate: TranslateService, private _userService: UserService, private _router: Router,
    private _route: ActivatedRoute, private _notification: NotificationService, private _profile: ProfileService) {
    this.steps.push({ name: [translate.instant('TOOLBAR.STEP.PROFILE')], ref: ["profile"] })
  }

  ngOnInit() {
    if (!this._user.isLoggedIn()) {
      this._router.navigate([''], { queryParams: { redirect: 'profile' } });
    } else {
      this._profile.me().subscribe(
        (me: any) => this.me = me,
        err => this._notification.errorServer(err)
      );
    }
  }


  ngAfterViewInit() {
    var accepted = this._route.params.subscribe(params => {
      this.accepted = params['accepted'] == '1';
      this.updateFromEmailVerified(this.accepted);
    });

  }

  updateFromEmailVerified(verified) {
    this.me.fromEmailVerified = verified;
    this._profile.update(this.me).subscribe(
      (ret: any) => {
        //this._notification.success('MESSAGE.SUCCESS', '');
        _.merge(this.me, ret.profile);
      },
      err => this._notification.errorServer(err)
    )
  }

  goToProfile() {
    this._router.navigate(['profile']);
  }

  done() {
    this._router.navigate(['']);
  }


}
